import React from "react";

// Navigate
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Mui Styles
import { AccordionTheme } from "@/styles/mui/accordionTheme";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
// import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import DateSelection from "@/components/dateSelection";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import IconButton from "@mui/material/IconButton";
// Compoents
import LocationDialog from "@/components/Dialog/locationDialog";
import Layout from "@/components/layout";
import StaffDetailCard from "@/components/staffDetailCard";
import Title from "@/components/title";
import Checkbox from "@mui/material/Checkbox";
// Fetch
import {
  getProductInvoice,
  updateInvoceWorkLocation,
} from "@/fetch/fetchProduct";
import { getShopSalesTagetTotal } from "@/fetch/fetchTarget";
// import { getUserProductInvoiceTotal } from "@/fetch/fetchStaff";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

import { CurrencyFormat, invoiceFormat } from "@/config/normalConfig";
import { useCurrentAction } from "@/hooks/user";
import { getRosterList } from "@/lib/getRosterList";
import { useSelector } from "react-redux";

import _ from "lodash";
const DailyDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const location = useLocation();

  const { pathname } = location;
  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });

  const { id, targetDatetime } = useParams();
  // const location = useLocation();

  // Navigate
  const navigate = useNavigate();
  const defaultStartDate =
    moment(targetDatetime).startOf("month").format("YYYY-MM-DD") ||
    moment().startOf("month").format("YYYY-MM_DD");
  const defaultEndDate =
    moment(targetDatetime).endOf("month").format("YYYY-MM-DD") ||
    moment().endOf("month").format("YYYY-MM-DD");

  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  // States
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [tranShopDialog, setTranShopDialog] = React.useState(false);
  const [productInvoiceItem, setProductInvoiceItem] = React.useState([]);
  const [shopTargetSalesTotal, setShopTargetSalesTotal] = React.useState(0);
  const [shopInvoiceTotal, setShopInvoiceTotal] = React.useState(0);
  const [selectedInvoice, setSelectedInvoice] = React.useState([]);
  const [selectedShop, setSelectedShop] = React.useState(null);
  const [currentShop, setCurrentShop] = React.useState(null);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [href, setHref] = React.useState(false);

  const handleClickCheckbox = (e, invoice) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectedInvoice((prev) => [...prev, invoice]);
    } else {
      setSelectedInvoice((prev) =>
        _.filter(prev, (old) => old.id !== invoice.id)
      );
    }
  };
  const onSubmit = async () => {
    setHref(false);
    try {
      await updateInvoceWorkLocation(
        parseInt(selectedShop.value),
        _.map(selectedInvoice, "id")
      );
      setSnackSeverity("success");
      setHref(`/daily/detail/${selectedShop.value}/${targetDatetime}`);
      setSnackMessage(`轉換成功，按此查看`);
    } catch (error) {
      setSnackSeverity("error");
      setSnackMessage(`轉換失敗`);
    } finally {
      setSelectedInvoice([]);
      setTranShopDialog(false);
      setSnackOpen(true);
      await fetchAll();
    }
  };
  const fetchAll = async () => {
    if (id && targetDatetime) {
      await getShopSalesTagetTotal(
        id,
        moment(targetDatetime).format("YYYY-MM-01")
      ).then((data) => {
        if (data && data.results) {
          setShopTargetSalesTotal(...data.data);
          setCurrentShop(data.data[0].work_name);
        } else {
          setShopTargetSalesTotal();
        }
      });
      await getProductInvoice(id, startDate, endDate).then(async (data) => {
        if (data && data.results) {
          setProductInvoiceItem(data.data);
          const total = _.reduce(
            data.data,
            (result, value) => {
              return Number(value.invoice_total) + result;
            },
            0
          );
          setShopInvoiceTotal(total);
          setTimeout(() => {
            setSlideTranOn(true);
          }, 200);
        } else {
          setProductInvoiceItem([]);
        }
      });
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="DailyDetailPage"
      selectedIndex={3}
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      href={href}
    >
      <Title
        title={`銷售追蹤 / 詳細資料`}
        history={() => navigate(-1)}
        children={
          actions?.transfer ? (
            <IconButton
              disabled={selectedInvoice.length <= 0}
              color={"primary"}
              component="label"
              onClick={() => setTranShopDialog(true)}
            >
              <SwapHorizIcon />
            </IconButton>
          ) : null
        }
      />
      <LocationDialog
        onSubmit={onSubmit}
        currentShop={currentShop}
        submitMessage={"轉換"}
        cancelMessage={"取消"}
        selectedShop={selectedShop}
        onCancel={() => setTranShopDialog(false)}
        handleOnShopChange={setSelectedShop}
        open={tranShopDialog}
      ></LocationDialog>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 6,
          }}
        >
          <StaffDetailCard
            {...shopTargetSalesTotal}
            shopInvoiceTotal={shopInvoiceTotal}
            noHover={true}
            type={"shop"}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 6,
          }}
        >
          <StyledPaper page={"yes"} alignItems={"left"}>
            <ThemeProvider theme={theme}>
              <Grid container spacing={2}>
                <DateSelection
                  defaultStartDate={defaultStartDate}
                  defaultEndDate={defaultEndDate}
                ></DateSelection>
              </Grid>
            </ThemeProvider>
          </StyledPaper>
        </Grid>

        <Grid size={12}>
          <Fade in={slideTranOn} mountOnEnter unmountOnExit>
            <div>
              <ThemeProvider theme={AccordionTheme}>
                {productInvoiceItem.length > 0 &&
                  productInvoiceItem.map((data, index) => (
                    <Accordion
                      sx={{ width: "100%" }}
                      key={index}
                      TransitionProps={{ unmountOnExit: true }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel-${data.index}`}
                        id={`panel-${data.index}-header`}
                      >
                        <Typography>
                          {actions?.transfer && (
                            <Checkbox
                              onChange={(e) => handleClickCheckbox(e, data)}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                              checked={Boolean(
                                selectedInvoice.find(
                                  (invoice) => invoice.id === data.id
                                )
                              )}
                            ></Checkbox>
                          )}
                          {data.full_name} - {invoiceFormat(data.id)} -{" "}
                          {moment(data.tx_date).format("YYYY-MM-DD")}{" "}
                          {getRosterList(data.roster)} -{" "}
                          {CurrencyFormat(data.invoice_total)}
                        </Typography>
                      </AccordionSummary>

                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="left" colSpan={4}>
                                報數清單
                              </TableCell>
                              <TableCell align="right">價錢</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>物品名稱</TableCell>
                              <TableCell align="right">數量</TableCell>
                              <TableCell align="right">單件價錢</TableCell>
                              <TableCell align="right">單件折扣價錢</TableCell>
                              <TableCell align="right">總數</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data.item.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>{item.product_name}</TableCell>
                                <TableCell align="right">
                                  {item.product_item_qty}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  style={{
                                    textDecorationLine:
                                      CurrencyFormat(
                                        item.product_discount_price
                                      ) > CurrencyFormat(0) &&
                                      moment(item.tx_date).isBetween(
                                        moment(item.product_discount_startdate),
                                        moment(item.product_discount_enddate),
                                        undefined,
                                        "[]"
                                      )
                                        ? "line-through"
                                        : "none",
                                  }}
                                >
                                  {CurrencyFormat(item.product_unit_price)}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  style={{
                                    textDecorationLine:
                                      (CurrencyFormat(
                                        item.product_discount_price
                                      ) > CurrencyFormat(0) &&
                                        !moment(item.tx_date).isBetween(
                                          moment(
                                            item.product_discount_startdate
                                          ),
                                          moment(item.product_discount_enddate),
                                          undefined,
                                          "[]"
                                        )) ||
                                      CurrencyFormat(
                                        item.product_discount_price
                                      ) === CurrencyFormat(0)
                                        ? "line-through"
                                        : "none",
                                  }}
                                >
                                  {CurrencyFormat(item.product_discount_price)}
                                </TableCell>
                                <TableCell align="right">
                                  {CurrencyFormat(item.product_discount_price) >
                                    CurrencyFormat(0) &&
                                  moment(item.tx_date).isBetween(
                                    moment(item.product_discount_startdate),
                                    moment(item.product_discount_enddate),
                                    undefined,
                                    "[]"
                                  )
                                    ? CurrencyFormat(
                                        item.product_discount_total
                                      )
                                    : CurrencyFormat(item.product_unit_total)}
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                              <TableCell colSpan={1}>
                                建立日期 :{" "}
                                {moment(data.tx_date).format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell rowSpan={1} colSpan={2} />
                              <TableCell colSpan={1}>全單總數</TableCell>
                              <TableCell colSpan={1} align="right">
                                {CurrencyFormat(data.invoice_total)}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Accordion>
                  ))}
              </ThemeProvider>
            </div>
          </Fade>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default DailyDetailPage;
